export const PERIOD = 'period';

export const APPLICATION_SPEND = 'applicationSpend';
export const APPLICATION = 'appId';
export const SPEND = 'spend';
